module.exports = __webpack_public_path__ + "img/padlock.b2b4911a.svg";